// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pens-window {
    display: flex;
    height: fit-content;
    border-style: solid;
    border-width: 1px;
    border-color: gray;
    width: 100%;
    height: 100%;
    flex-direction: column;
}

.modal-header {
    min-width: 250px;
    display: flex;
    justify-content: space-between;
    background: #1E90FF;
    color: #fff;
    align-items: center;
}
.modal-body{
    flex: 1;
    overflow: auto;
    overflow: visible;
}

.modal-label{
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    color: #fff;
}
.modal-close {
    cursor: pointer;
}

.modal-close svg {
    fill: #fff;
}

.modal-close:hover {
    background-color: red;
}`, "",{"version":3,"sources":["webpack://./src/controls/common/modal/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".pens-window {\r\n    display: flex;\r\n    height: fit-content;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: gray;\r\n    width: 100%;\r\n    height: 100%;\r\n    flex-direction: column;\r\n}\r\n\r\n.modal-header {\r\n    min-width: 250px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    background: #1E90FF;\r\n    color: #fff;\r\n    align-items: center;\r\n}\r\n.modal-body{\r\n    flex: 1;\r\n    overflow: auto;\r\n    overflow: visible;\r\n}\r\n\r\n.modal-label{\r\n    padding-left: 10px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis; \r\n    color: #fff;\r\n}\r\n.modal-close {\r\n    cursor: pointer;\r\n}\r\n\r\n.modal-close svg {\r\n    fill: #fff;\r\n}\r\n\r\n.modal-close:hover {\r\n    background-color: red;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
